import store from '@/store'
import SUBUSER_PERMISSION_SLUGS from '@/constants/authorization/subuser-permission-slugs'

export default [
  {
    title: 'inventory.title',
    svgIcon: 'icon-inventory',
    hide: () => !store.getters['subscription/hasInventory'],
    children: [
      {
        title: 'inventory.units.title',
        svgIcon: 'icon-units',
        route: 'admin:inventory:units',
        permission: SUBUSER_PERMISSION_SLUGS.INVENTORY_UNITS_VIEW,
      },
      {
        title: 'inventory.suppliers.title',
        svgIcon: 'icon-suppliers',
        route: 'admin:inventory:suppliers',
        permission: SUBUSER_PERMISSION_SLUGS.INVENTORY_SUPPLIERS_VIEW,
      },
      {
        title: 'inventory.items.ingredients',
        svgIcon: 'icon-inventory-items',
        route: 'admin:inventory:ingredients',
        permission: SUBUSER_PERMISSION_SLUGS.INVENTORY_INGREDIENTS_VIEW,
      },
      {
        title: 'inventory.items.recipes',
        svgIcon: 'icon-inventory-recipes',
        route: 'admin:inventory:recipes',
        permission: SUBUSER_PERMISSION_SLUGS.INVENTORY_RECIPES_VIEW,
      },
      {
        title: 'inventory.items.count',
        svgIcon: 'icon-inventory-count',
        route: 'admin:inventory:branches',
        permission: SUBUSER_PERMISSION_SLUGS.INVENTORY_STOCK_VIEW,
      },
      {
        title: 'inventory.spotCheck.title',
        svgIcon: 'icon-inventory-spot-check',
        svgIconSize: 16,
        route: 'admin:inventory:spot-check',
        permission: SUBUSER_PERMISSION_SLUGS.INVENTORY_SPOT_CHECKS_VIEW,
      },
      {
        title: 'inventory.inventoryCount.title',
        svgIcon: 'icon-inventory-counts',
        svgIconSize: 16,
        route: 'admin:inventory:inventory-count',
        permission: SUBUSER_PERMISSION_SLUGS.INVENTORY_COUNTS_VIEW,
      },
      {
        title: 'inventory.transactions.title',
        svgIcon: 'icon-inventory-transactions',
        route: 'admin:inventory:transactions',
        permission: SUBUSER_PERMISSION_SLUGS.INVENTORY_TRANSACTIONS_VIEW,
      },
      {
        title: 'inventory.report.title',
        svgIcon: 'icon-stock-report',
        route: 'admin:inventory:report',
        permission: SUBUSER_PERMISSION_SLUGS.REPORTS_INVENTORY_VIEW,
      },
    ],
  },

]
